import { LazyMotion, domAnimation, m } from "framer-motion";
import React from "react";
import { skills } from "../../Constants/Constants";
import "./skill-cards.scss";

const SkillsCards = () => {
  return (
    <div className="flex">
      <LazyMotion features={domAnimation} strict>
        {skills.map((skill, index) => (
          <m.div
            initial={{ scale: 0.8 }}
            animate={{
              rotate: [0, 10, 0],
            }}
            transition={{
              duration: 1,
              repeat: Infinity,
              repeatType: "loop",
              ease: "linear",
            }}
            style={{ zIndex: `${index + 1}` }}
            key={index}
            className="card w-[300px] flex flex-col items-center rounded-xl border-4 cursor-pointer orange-background"
          >
            <div className="w-full flex items-center gap-2 p-1 flex-col skill-cards-content-wrapper">
              <img
                className="h-[50px] flex justify-center items-center w-[50px] rounded-[50%] p-1 object-contain skill-icon"
                src={skill.icon}
                alt={skill.title}
              />
              <span className="text-xl skill-title">{skill.title}</span>
              <span className="text-center text-grayscale-950 rounded-xl text-sm skill-description">
                {skill.description}
              </span>
            </div>
          </m.div>
        ))}
      </LazyMotion>
    </div>
  );
};

export default SkillsCards;
